import * as React from "react";
import { FlowForm } from "src/components/CreateFlow/FlowForm";

type FlowsCreatePageProps = {};

export const FlowsCreatePage: React.FC<FlowsCreatePageProps> = () => {
  return <FlowForm />;
};
